<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management' }">个人赛赛务工具</el-breadcrumb-item>
      <el-breadcrumb-item>试卷申请管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">学校信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛区" prop="districtIdList">
              <el-select
                multiple
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.districtIdList"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学校省市区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                v-model="queryForm.schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  children: 'areas',
                }"
                @change="provincesHandleChange('search')"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学校名称" prop="schoolName">
              <el-input
                v-model="queryForm.schoolName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试卷申请状态" prop="applyStatus">
              <el-select
                placeholder="请选择"
                v-model="queryForm.applyStatus"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dict_considerationsState"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
                 <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="exportData()"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 学校列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">考量信息列表</span
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="赛区" prop="districtName"></el-table-column>
        <el-table-column label="学校名称" prop="schoolName" width="140">
          <template slot-scope="scope">
            <div class="school-name" @click="detailsConsiderationClicked(scope.row)">{{ scope.row.schoolName }}</div>
            <!-- <el-button
              type="text"
              size="small"
              @click="detailsConsiderationClicked(scope.row)"
              >{{ scope.row.schoolName }}</el-button
            > -->
          </template>
        </el-table-column>
        <el-table-column
          label="申请老师"
          prop="teacherName"
        ></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="年级" prop="gradeStr"></el-table-column>
        <el-table-column label="班级数" prop="classStr"></el-table-column>
        <el-table-column label="总考量" prop="examNum"></el-table-column>
        <el-table-column label="申请时间" prop="createTime"></el-table-column>
        <el-table-column label="预计考试时间" prop="expectedTime"></el-table-column>
        <el-table-column
          label="进度状态"
          prop="applyStatus"
          :formatter="applyStatusFormatter"
        ></el-table-column>
        <el-table-column label="备注" prop="applyRemark"></el-table-column>
        <el-table-column label="审批人" prop="applyUserName"></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.applyStatus === 0"
              type="text"
              size="small"
              @click="auditApprovalClicked(scope.row)"
              >同意</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 0"
              type="text"
              size="small"
              @click="auditRefusedClicked(scope.row)"
              >拒绝</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 1"
              type="text"
              size="small"
              @click="sentRefusedClicked(scope.row)"
              >待寄出</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 3"
              type="text"
              size="small"
              @click="sentRefusedClicked(scope.row)"
              >确认寄回</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 4"
              type="text"
              size="small"
              @click="examinesFinishClicked(scope.row)"
              >完成批阅</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 5"
              type="text"
              size="small"
              @click="statisticalFinishClicked(scope.row)"
              >成绩统计完成</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 6"
              type="text"
              size="small"
              @click="publishedFinishClicked(scope.row)"
              >公布晋级结果</el-button
            >
            <el-button
              v-if="scope.row.applyStatus === 7"
              type="text"
              size="small"
              >成绩已公布</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 编辑信息的dialog -->
    <el-dialog
      title="操作内容"
      :visible.sync="refusedInfoDialogVisible"
      width="40%"
      @close="refusedInfoDialogClose"
    >
      <el-form
        :model="auditForm"
        label-width="100px"
        ref="refusedInfoFormRef"
        :rules="refusedInfoRules"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="18">
            <el-form-item label="拒绝原因" prop="applyRemark">
              <el-input
                type="textarea"
                v-model="auditForm.applyRemark"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refusedInfo">提 交</el-button>
      </span>
    </el-dialog>
     <!-- 寄出编辑信息的dialog -->
     <el-dialog
      title="邮寄信息"
      :visible.sync="expressInfoDialogVisible"
      width="40%"
      @close="expressInfoDialogClose"
    >
      <el-form
        :model="auditForm"
        label-width="100px"
        ref="expressInfoFormRef"
        :rules="expressInfoRules"
        style="width: 100%"
      >
      <el-form-item label="快递公司" prop="expressType">
              <el-select
                placeholder="请选择"
                v-model="auditForm.expressType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dict_express"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="快递单号" prop="expressNumber">
              <el-input
                type="textarea"
                v-model="auditForm.expressNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sentInfo">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import areasData from '@/assets/area.json'
import { getPaperApplyList, processPaperApply, queryDistrictPage, paperApplyExpressDelivery, updatePaperStatusDTO } from '@/http/api'
export default {
  data () {
    return {
      expressInfoDialogVisible: false,
      refusedInfoDialogVisible: false,
      dict_considerationsState: this.$userInfo.dict_considerationsState(),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_express: this.$userInfo.getDataList(this, 'express_type').then(value => { this.dict_express = value }),
      dict_group: this.$userInfo.dict_group(),
      total: 0,
      dict_district: [],
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        districtIdList: '',
        season: this.$chnEngStatusCode.defaultSeason
      },
      auditForm: {
        expressType: '',
        expressNumber: '',
        applyRemark: ''
      },
      expressInfoRules: {
        expressType: [{ required: true, message: '请选择', trigger: 'change' }],
        expressNumber: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      refusedInfoRules: {
        refused: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      dict_schoolType: this.$userInfo.dict_schoolType(),
      dataList: [],
      areasData: areasData.areas
    }
  },

  created () {
    if (this.$route.query.status) {
      this.queryForm.applyStatus = this.$route.query.status
    } else {
      this.queryForm.applyStatus = ''
    }
    this.getDistrictList()
    this.getDataList()
  },
  // created () {
  //   // this.getDataList()
  // },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        this.getQueryDistrictTimePage()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取学校列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getPaperApplyList(this.queryForm).then((res) => {
        console.log('getPaperApplyList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      console.log('value', value)
      if (value === 'addSchool') {
        this.editInfoForm.provinceCode = this.editInfoForm.schoolArea[0]
        this.editInfoForm.cityCode = this.editInfoForm.schoolArea[1]
        this.editInfoForm.areaCode = this.editInfoForm.schoolArea[2]
        const deliveryAreaName = this.$refs.schoolAreaRef.getCheckedNodes()[0].pathLabels.join('/')
        const areaList = deliveryAreaName.split('/')
        this.editInfoForm.province = areaList[0]
        this.editInfoForm.city = areaList[1]
        this.editInfoForm.area = areaList[2]
      } else {
        this.queryForm.provinceCode = this.queryForm.schoolArea[0]
        this.queryForm.cityCode = this.queryForm.schoolArea[1]
        this.queryForm.areaCode = this.queryForm.schoolArea[2]
        const deliveryAreaName = this.$refs.schoolAreaRef.getCheckedNodes()[0].pathLabels.join('/')
        const areaList = deliveryAreaName.split('/')
        this.queryForm.province = areaList[0]
        this.queryForm.city = areaList[1]
        this.queryForm.area = areaList[2]
      }
    },
    applyStatusFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_considerationsState) {
        if (Object.hasOwnProperty.call(this.dict_considerationsState, key)) {
          const element = this.dict_considerationsState[key]
          if (element.dictValue === data.applyStatus + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    // 重置搜索条件
    reset () {
      this.queryForm.pageNum = 1
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 同意点击事件
    auditApprovalClicked (rowData) {
      this.auditForm.applyStatus = 1
      this.auditForm.id = rowData.id
      this.approveSchoolapply()
    },
    // 拒绝点击事件
    auditRefusedClicked (rowData) {
      this.auditForm.applyStatus = 2
      this.auditForm.id = rowData.id
      this.refusedInfoDialogVisible = true
    },
    // 拒绝原因提交
    refusedInfo () {
      // this.$refs.refusedInfoFormRef.resetFields()
      this.refusedInfoDialogVisible = false
      this.approveSchoolapply()
    },
    // 待寄出点击
    sentRefusedClicked (rowData) {
      console.log('rowData', rowData)
      if (rowData.applyStatus === 1) {
        this.auditForm.applyType = 0
      } else if (rowData.applyStatus === 3) {
        this.auditForm.applyType = 1
      }
      this.auditForm.paperId = rowData.id
      this.expressInfoDialogVisible = true
    },
    expressInfoDialogClose () {
      this.$refs.expressInfoFormRef.resetFields()
    },
    // 试卷寄出信息提交
    sentInfo () {
      this.paperApplyExpressDelivery()
    },
    // 试卷寄出信息提交接口
    paperApplyExpressDelivery () {
      paperApplyExpressDelivery(this.auditForm).then((res) => {
        this.$refs.expressInfoFormRef.resetFields()
        this.expressInfoDialogVisible = false
        this.$message.success('操作成功')
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 学校审核接口
    approveSchoolapply () {
      processPaperApply(this.auditForm).then((res) => {
        this.$message.success('操作成功')
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 批阅完成点击事件
    examinesFinishClicked (rowData) {
      this.$confirm('是否已确认该套试卷批阅完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updatePaperStatusDTO(rowData)
      }).catch(() => {
      })
    },
    // 试卷批阅完成请求
    updatePaperStatusDTO (rowData) {
      var formData = {}
      if (rowData.applyStatus === 4) {
        formData.applyStatus = 5
      } else if (rowData.applyStatus === 5) {
        formData.applyStatus = 6
      } else if (rowData.applyStatus === 6) {
        formData.applyStatus = 7
      }
      formData.id = rowData.id
      updatePaperStatusDTO(formData).then((res) => {
        this.$message.success('操作成功')
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    statisticalFinishClicked (rowData) {
      this.$confirm('是否已确认该套试卷已完成成绩统计？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updatePaperStatusDTO(rowData)
      }).catch(() => {
      })
    },
    publishedFinishClicked (rowData) {
      this.$confirm('是否要公布该套试卷晋级结果？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updatePaperStatusDTO(rowData)
      }).catch(() => {
      })
    },
    //  查看详情
    detailsConsiderationClicked (rowData) {
      this.$router.push({
        path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_management_detail',
        query: {
          schoolDetailId: rowData.id
        }
      })
    },
    exportData () {
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 100000000
      const downLoadUrl = `${this.$http.defaults.baseURL}paper/exportPaperApplyList`
      this.$downLoadFile.downLoadFileWithUrlNew(this, downLoadUrl, this.queryForm)
    },
    refusedInfoDialogClose () {
      this.$refs.refusedInfoFormRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.div_algin_right {
  text-align: right;
}
.school-name{
  color: #409EFF;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  &:hover{
    color: #66b1ff;
  }
}
</style>
